/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListAllTasksForOfflineQueryResponse, ListAllTasksForOfflinePathParams, ListAllTasksForOfflineQueryParams, ListAllTasksForOffline400, ListAllTasksForOffline401, ListAllTasksForOffline403, ListAllTasksForOffline404, ListAllTasksForOffline409, ListAllTasksForOffline500 } from "../../types/planningTasksController/ListAllTasksForOffline.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listAllTasksForOffline } from "../../client/planningTasksController/listAllTasksForOffline.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listAllTasksForOfflineQueryKey = (organizationId: ListAllTasksForOfflinePathParams["organizationId"] | undefined, params?: ListAllTasksForOfflineQueryParams) => [{ url: '/api/organizations/:organizationId/tasks/all', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type ListAllTasksForOfflineQueryKey = ReturnType<typeof listAllTasksForOfflineQueryKey>

export function listAllTasksForOfflineQueryOptions(organizationId: ListAllTasksForOfflinePathParams["organizationId"] | undefined, params?: ListAllTasksForOfflineQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listAllTasksForOfflineQueryKey(organizationId, params)
        return queryOptions<ListAllTasksForOfflineQueryResponse, ResponseErrorConfig<ListAllTasksForOffline400 | ListAllTasksForOffline401 | ListAllTasksForOffline403 | ListAllTasksForOffline404 | ListAllTasksForOffline409 | ListAllTasksForOffline500>, ListAllTasksForOfflineQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return listAllTasksForOffline(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Full non-paginated task dataset for offline preparation (capped at 10 000)
 * {@link /api/organizations/:organizationId/tasks/all}
 */
export function useListAllTasksForOffline<TData = ListAllTasksForOfflineQueryResponse, TQueryData = ListAllTasksForOfflineQueryResponse, TQueryKey extends QueryKey = ListAllTasksForOfflineQueryKey>(organizationId: ListAllTasksForOfflinePathParams["organizationId"] | undefined, params?: ListAllTasksForOfflineQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListAllTasksForOfflineQueryResponse, ResponseErrorConfig<ListAllTasksForOffline400 | ListAllTasksForOffline401 | ListAllTasksForOffline403 | ListAllTasksForOffline404 | ListAllTasksForOffline409 | ListAllTasksForOffline500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listAllTasksForOfflineQueryKey(organizationId, params)
         

         const query = useQuery({
          ...listAllTasksForOfflineQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListAllTasksForOffline400 | ListAllTasksForOffline401 | ListAllTasksForOffline403 | ListAllTasksForOffline404 | ListAllTasksForOffline409 | ListAllTasksForOffline500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}